module.exports = __webpack_public_path__ + "ee4472d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/telegram_icon.png
// module id = 2074
// module chunks = 15 17 32 36